import { render, staticRenderFns } from "./IconEmojiHappy.vue?vue&type=template&id=a52374ce&"
import script from "./IconEmojiHappy.vue?vue&type=script&lang=js&"
export * from "./IconEmojiHappy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports